<template>
    <div
        class="flex gap-x-4 items-center text-black text-opacity-75"
        @click="copyHash"
    >
        <span class="font-bold">
            {{ value }}
        </span>
        <div
            v-tippy="tooltip"
            class="border border-gray-300 rounded-full w-8 h-8 flex justify-center items-center cursor-pointer"
        >
            <i class="far fa-copy" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: { type: String, default: '' },
        tooltip: { type: String, default: '' }
    },
    methods: {
        copyHash(data) {
            if ("clipboard" in navigator) {
                navigator.clipboard.writeText(this.value).then(() => {
                    this.$toast.success("Hash copiada com sucesso", {
                        position: "top-right"
                    });
                });
            }
        }
    }
};
</script>
